const BYTES_PER_KB = 1024;
const UNITS = ["B", "KB", "MB", "GB", "TB"];

/** Renders a byte count for people: 1536 -> "1.5 KB", 1048576 -> "1 MB". */
export function formatBytes(bytes) {
  if (!Number.isFinite(bytes) || bytes <= 0) return "0 B";

  let value = bytes;
  let unit = 0;

  while (value >= BYTES_PER_KB && unit < UNITS.length - 1) {
    value /= BYTES_PER_KB;
    unit++;
  }

  return `${parseFloat(value.toFixed(1))} ${UNITS[unit]}`;
}
